import React, { FC } from 'react';
import Alert, { AlertTypes } from '@common/components/Alert/Alert';

type GroupErrorProps = {
  meta: { submitFailed: boolean; error?: string };
};

export const GroupError: FC<GroupErrorProps> = ({ meta }) =>
  meta.submitFailed && meta?.error ? <Alert type={AlertTypes.Error} content={meta.error} /> : null;
